import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import * as React from 'react';
import { useNavigation } from 'react-router-dom';

NProgress.configure({ showSpinner: false, speed: 300, minimum: 0.1 });

export function TopLoadingBar(): null {
  const { state } = useNavigation();

  React.useEffect(() => {
    if (state === 'loading') {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [state]);

  return null;
}
